import { useState } from 'react'
import { useFormikContext } from 'formik'
import SearchBox from 'components/SearchBox'
import DoubleToggleButton from 'components/DoubleToggleButton'
import SelectableRevenueCentersList from 'components/SelectableItemsList/SelectableRevenueCentersList'
import CheckboxIndeterminate from 'components/CheckboxIndeterminate'
import { selectableListItems } from 'utils/selectableList'
import { revenueCentersFilterOptions } from 'resources'

import classNames from 'classnames'

const RevenueCenters = ({ allRevenueCenters, goBack }) => {
  // formik
  const { values, setFieldValue } = useFormikContext()

  // states
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedToggleButton, setSelectedToggleButton] = useState('all')
  
  const handleChangeDoubleToggleButton = (uuid) => {
    setSelectedToggleButton(uuid)
  }

  // displayed items on the list
  const {
    filteredItemsBySelectedFilterOption,
    checkedItemsWithinFilteredItemsUuids,
    itemsSelectedNotDisplayed,
    isCheckAll,
    isIndeterminate,
    isDisabled,
  } = selectableListItems(
    allRevenueCenters,
    searchQuery,
    selectedToggleButton,
    values?.revenueCenters,
  )

  // handlers
  const handleCheckAllRevenueCenters = () => {
    // if some items are selected, select all
    if ( checkedItemsWithinFilteredItemsUuids.length < filteredItemsBySelectedFilterOption.length) {
      setFieldValue('revenueCenters', [
        ...filteredItemsBySelectedFilterOption.map(
          (item) => item.uuid
        ),
        ...itemsSelectedNotDisplayed,
      ])
      return {
        checked: true,
        indeterminate: false,
      }
      // if all items are selected, unselect all
    }
    
    if (
      checkedItemsWithinFilteredItemsUuids.length ===
      filteredItemsBySelectedFilterOption.length
    ) {
      setFieldValue('revenueCenters', itemsSelectedNotDisplayed)
      return {
        checked: false,
        indeterminate: false,
      }
      // if some items are selected, select all
    } 
    
    if (checkedItemsWithinFilteredItemsUuids.length === 0) {
      return {
        checked: false,
        indeterminate: true,
      }
    }
  }

  const handleCheckboxChange = (selectedCenterUUID) => {
    if (values?.revenueCenters?.includes(selectedCenterUUID)) {
      setFieldValue(
        'revenueCenters',
        values?.revenueCenters?.filter((uuid) => uuid !== selectedCenterUUID)
      )
    } else {
      setFieldValue('revenueCenters', [...values.revenueCenters, selectedCenterUUID])
    }
  }

  const handleSave = () => {
    goBack()
  }

  return (
    <div className="item-settings">
      <section className="selectable-items"> 
        <SearchBox
          value={searchQuery}
          onChange={setSearchQuery}
          placeholder="Search..."
        />
        <div className="selectable-items__searchbox">
          <DoubleToggleButton
            options={revenueCentersFilterOptions}
            selectedUuid={selectedToggleButton}
            onChange={handleChangeDoubleToggleButton}
          />
        </div>
        <CheckboxIndeterminate
          handleChange={handleCheckAllRevenueCenters}
          checked={values.revenueCenters === null ? true: isCheckAll}
          indeterminate={isIndeterminate}
          label="All Revenue Centers"
          className={
            classNames(isCheckAll ? '-checkbox-indeterminate-checked' : '',
            isDisabled ? '-disabled' : '')
          }
          disabled={isDisabled}
        />
        <SelectableRevenueCentersList
          handleChange={handleCheckboxChange}
          items={filteredItemsBySelectedFilterOption}
          selectedItems={values.revenueCenters}
        />
      </section>
      <footer className="selectable-items__footer">
        <button
          className="btn -primary selectable-items__submit-btn"
          onClick={handleSave}
        >
          Save
        </button>
      </footer>
    </div>
  )
}
export default RevenueCenters
